import { FormattedMessage } from 'react-intl';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { FeatureFlagDeclarations } from '../../../../feature-flags/feature-flag-declarations';
import { goToOrderDetails } from '../../../../store/orders/order-details/orders.details.actions';
import { NavigationButton } from '../../side-panel/navigation-panel/navigation-button';
import { useFeatureFlag } from '../../../../feature-flags/hooks/use-feature-flag';
import { useSalesOrderIdContext } from '../../../context/sales-order-id-context-provider';
import { useShowOrderOverview } from '../../hooks/use-show-order-overview';

import { messages } from './messages';
import style from './style.module.less';

export const OrderOverviewButton = () => {
  const dispatch = useDispatch();
  const salesOrderId = useSalesOrderIdContext();
  const hasOrderOverviewEnabled = useFeatureFlag(FeatureFlagDeclarations.enableOrderOverview);
  const showOrderOverview = useShowOrderOverview();

  const navigateToOrderOverview = useCallback(() => {
    dispatch(
      goToOrderDetails({
        salesOrderId,
        selectOrderInGrid: false,
      }),
    );
  }, [dispatch, salesOrderId]);

  const isSelected = showOrderOverview;

  return (
    hasOrderOverviewEnabled && (
      <div className={style['overview-navigation']}>
        <NavigationButton
          iconClassName={style['overview-icon']}
          iconName='faFileInvoice'
          isSelected={isSelected}
          onClick={navigateToOrderOverview}
        >
          <FormattedMessage {...messages.button} />
        </NavigationButton>
        <div className={style.divider} />
      </div>
    )
  );
};
